import React from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'

export default function PaymentProofBalanceChoiceDialog({
  open,
  applying,
  error,
  onClose,
  onProceedWithBalance,
  onUploadProofDeposit,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Payment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          You have available balance, are you sure you want to upload proof of payment?
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ flexDirection: 'column', alignItems: 'stretch', gap: 1, px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onProceedWithBalance}
          disabled={applying}
        >
          {applying ? 'Applying…' : 'Proceed with Available Balance'}
        </Button>
        <Button variant="outlined" onClick={onUploadProofDeposit} disabled={applying}>
          Upload Proof of Payment Deposit
        </Button>
        <Button onClick={onClose} disabled={applying}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
